import { useEffect, useState } from "react";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { BackButton } from "../../../../Components/Utils/Buttons";
import axiosInstance from "../../../../Services/axiosCommon";
import { TextMediumBase, TextMediumSM } from "../../../../Components/Text/MediumText";

import Client from "./Client";
import Contracts from "./Contracts";
import SurveyReport from "./SurveyReport";
import InspectionSchedule from "./InspectionSchedule";
import Equipments from "./Equipments";
import ClientTickets from "./ClientTickets";
import SupportTicket from "./SupportTicket";
import Suppliers from "./Suppliers";
import { GetAccess } from "../../../../Components/Utils/roles";
import InvoiceOut from "./InvoiceOut";
import CollectAndReturn from "./CollectionAndReturn";
import CommisioningSchedule from "./CommisioningSchedule";
import { BookOpenText, FileText, ListOrdered } from "lucide-react";
import { HeadingWithIcon } from "../../../../Components/Utils/Settingheading";



const ReffrenceSettings = () => {
  
  return (
    <div className="w-full h-full px-4 py-2">
      <div className="w-full flex justify-between items-center">
        <Breadcrumb
          items={[
            {
              name: "Settings",
            },
            {
              name: "Reference",
            },
          ]}
        />
        <BackButton />
      </div>
      <div className="w-full h-[calc(100vh-145px)] bg-white mt-3 mx-auto  p-2 rounded-md overflow-hidden">
     <HeadingWithIcon icon={FileText} title="Reference List" />
        {/* <form onSubmit={formik?.handleSubmit}> */}
        <div className="w-full max-h-[calc(100vh-200px)] overflow-y-auto mt-2">
  <div className="flex flex-row">
    <div className="w-1/5 text-left text-sm font-medium py-4 px-4">Module Name</div>
    <div className="w-1/5 text-center text-sm font-medium py-2 px-4"><p>Prefix</p><p className="text-[10px] text-gray-400">1 to 10 Any Alphabet</p></div>
    <div className="w-1/5 text-center text-sm font-medium py-2 px-4"><p>Suffix</p><p className="text-[10px] text-gray-400">3 to 15 Any Numbers</p></div>
    <div className="w-1/5 text-center text-sm font-medium py-4 px-4">Display Zero</div>
    {GetAccess('reference_edit')&&
    <div className="w-1/5 text-center text-sm font-medium py-4 px-4">Save</div>}
  </div>
  <div>
    <Client />
   
    <Contracts/>
    <SurveyReport/>
    <InspectionSchedule/>
    <CommisioningSchedule/>

      <Equipments/>
    <CollectAndReturn/>

    <ClientTickets/>
    <SupportTicket/>
    <InvoiceOut/>

    <Suppliers/>
   
   
  </div>
</div>

        {/* </form> */}
      </div>
    </div>
  );
};

export default ReffrenceSettings;
